import { createSelector } from '@reduxjs/toolkit'
import flush from 'just-flush'

import { OrdersState } from '@/ducks/orders/slices/orders.slice'

const selectOrders = (state: { orders: OrdersState }) => state.orders
const selectDriverNames = (state: { orders: OrdersState }) => state.orders.driverNames;

export const selectOrdersList = createSelector(
  selectOrders,
  orders => orders.ordersList
)

export const selectIsOrdersLoading = createSelector(
  selectOrders,
  orders => orders.loadingStates.getOrdersRequest === 'loading'
)

export const selectOrderFilters = createSelector(selectOrders, orders => {
  return orders.filters
})
export const selectOrderSearchParams = createSelector(selectOrders, orders => {
  return orders.searchParams
})

export const selectHasFilters = createSelector(selectOrders, orders => {
  const { statuses, ...restFilters } = orders.filters
  const hasStatuses = statuses !== undefined && statuses.length !== 0
  const hasCommonFilters = Object.entries(flush(restFilters)).length !== 0
  return hasCommonFilters || hasStatuses
})

export const selectHasSearch = createSelector(selectOrders, orders => {
  const { value } = orders.searchParams
  return !!value
})
// Selector

export const selectRemainingETA = (orderId: string) =>
  createSelector(
    selectOrders,
    (orders) => orders.ordersDetailsMap[orderId]?.remainingETA
  );

  export const selectDriverNameByOrderId = ( orderId: string) =>
    createSelector(selectDriverNames, driverNames => driverNames[orderId]);



